module.exports = __webpack_public_path__ + "img/serviceicon1.a1cc9b7b.gif";